var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "#00075e",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7C17 5.34315 18.3431 4 20 4H28C29.6569 4 31 5.34315 31 7H34C36.2091 7 38 8.79086 38 11V39C38 41.2091 36.2091 43 34 43H14C11.7909 43 10 41.2091 10 39V11C10 8.79086 11.7909 7 14 7H17ZM20 6C19.4477 6 19 6.44772 19 7V9C19 9.55228 19.4477 10 20 10H28C28.5523 10 29 9.55228 29 9V7C29 6.44772 28.5523 6 28 6H20ZM17 26C16.4477 26 16 26.4477 16 27C16 27.5523 16.4477 28 17 28H31C31.5523 28 32 27.5523 32 27C32 26.4477 31.5523 26 31 26H17ZM16 32C16 31.4477 16.4477 31 17 31H31C31.5523 31 32 31.4477 32 32C32 32.5523 31.5523 33 31 33H17C16.4477 33 16 32.5523 16 32ZM17 36C16.4477 36 16 36.4477 16 37C16 37.5523 16.4477 38 17 38H27C27.5523 38 28 37.5523 28 37C28 36.4477 27.5523 36 27 36H17ZM20 14.9995C20.5523 14.9995 21 15.4472 21 15.9995V18H23C23.5523 18 24 18.4477 24 19C24 19.5523 23.5523 20 23 20H21V21.9998C21 22.552 20.5523 22.9998 20 22.9998C19.4477 22.9998 19 22.552 19 21.9998V20H17C16.4477 20 16 19.5523 16 19C16 18.4477 16.4477 18 17 18H19V15.9995C19 15.4472 19.4477 14.9995 20 14.9995Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinical);
export default __webpack_public_path__ + "static/media/clinical.24a7f066d833c2d767d08d27b14aa104.svg";
export { ForwardRef as ReactComponent };